import React, {useState} from 'react';
import maCateImg from "../../assets/img/m-a-cate.png";
import packEx1 from "../../assets/img/packingBox_1.jpg";
import packEx2 from "../../assets/img/packingBox_2.jpg";
import packEx3 from "../../assets/img/packingBox_3.jpg";
import TopBtn from "../../components/web/layoutsadmin/TopBtn";

export function TaskToggleSection({ title, children }) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="task-guide-wrapper wd-100pc p-l-15 p-r-15">
            <div className="task-guide-header" onClick={() => setIsOpen(o => !o)}>
                <div className="font-s-16">{title}</div>
                <div className="font-s-18" style={{ lineHeight: 1 }}>{isOpen ? '–' : '+'}</div>
            </div>{isOpen && <div className="task-guide-content">{children}</div>}
        </div>
    );
}

export function SubToggleSection({ title, children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="sub-toggle-wrapper">
            <div className="sub-toggle-header" onClick={() => setOpen(o => !o)}>
                <div className="sub-title">{title}</div>
                <div className="sub-icon">{open ? '▼' : '▷'}</div>
            </div>
            {open && (
                <div className="sub-toggle-content">
                    {children}
                </div>
            )}
        </div>
    );
}

function AdminTaskManagerPg() {

    /** region DataTable */

    const [taskData, setTaskData] = useState([]);

    /** endregion */

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');

    // region 탭기능

    const [activeCategory, setActiveCategory] = useState("Qna");

    const handleCategoryClick = (category) => {
        setActiveCategory(category);
    };

    // endregion

    /** endregion */

    /** region Event */

    /** endregion */

    // todo ■■■■■ 일단은 그냥 참고용으로 사용(저장없이). 데이터 연동 및 개선은 추후 필요 시 진행.

    return (
        <div className="AdminCountryInfoSetPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">협업관리</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <div className="pg-set-categories font-t-title font-s-17 m-b-10">
                        <div className={activeCategory === "Qna" ? "pg-set-active-category" : ""} onClick={() => handleCategoryClick("Qna")}>문의</div>
                        <div className={activeCategory === "Buy" ? "pg-set-active-category" : ""} onClick={() => handleCategoryClick("Buy")}>구매</div>
                        <div className={activeCategory === "Check" ? "pg-set-active-category" : ""} onClick={() => handleCategoryClick("Check")}>검수</div>
                        <div className={activeCategory === "Packing" ? "pg-set-active-category" : ""} onClick={() => handleCategoryClick("Packing")}>패킹/접수</div>
                        <div className={activeCategory === "OutToReturn" ? "pg-set-active-category" : ""} onClick={() => handleCategoryClick("OutToReturn")}>출고/반송</div>
                    </div>
                    <div className="pg-set-tab-content font-t-cont">
                        {activeCategory === "Qna" &&
                            <div className="banner-info-container">

                            </div>
                        }
                        {activeCategory === "Buy" &&
                            <div className="banner-info-container">

                            </div>
                        }
                        {activeCategory === "Check" &&
                            <div className="banner-info-container">

                            </div>
                        }
                        {activeCategory === "Packing" &&
                            <div className="banner-info-container p-t-15">
                                <TaskToggleSection title="패킹업무 가이드라인">
                                    <a>1. 검수 완료된 물품이 패킹존에 이동되면</a><a> 해당 물품의 주문정보(고객명, 사서함, 물품명, 운송장 등) 검색 후 랙에 적치 되어있는 물품들 피킹</a><a>(</a><a style={{color: "#ff5e97", fontWeight: "bold"}}>구매대행, </a><a style={{color: "#000000", fontWeight: "bold",}}>배송대행</a><a> 명확하게 구분하여 조회)</a>
                                    <br/><br/><br/>
                                    <a>2. 해당 고객의 물품이 전부 도착 했는지의</a><a style={{color: "#ff5252", fontWeight: "bold", fontSize: "18px"}}>⭐(번호, 사서함, 고객명)</a><a> 여부를 정확하게 확인 후 주문서의 </a><a style={{color: "#ff5252", fontWeight: "bold", fontSize: "18px"}}>⭐요청옵션, 요청상세, 주문서메모</a><a> 확인</a>
                                    <br/><br/><br/>
                                    <a>3. 위 절차가 정확하게 확인이 되었으면 패킹 진행</a><br/>
                                    <a>&nbsp;&nbsp;&nbsp; - 패킹 시 반드시 지켜야 할 조건: <a style={{color: "#ff5252", fontWeight: "bold", fontSize: "18px"}}>⭐ 안전하게, 빈공간 없이, 최대한 타이트하여 배송비가 저렴하게</a> (※ 아래 예시 이미지 참조)</a><br/>
                                    <a>&nbsp;&nbsp;&nbsp; - 택배박스 해체 시 박스안에 남아있는(누락) 물품이 없는지 자세히 확인<a style={{color: "#000000", fontWeight: "bold"}}>(종이, 영수증, 샘플, 사은품 등 작은 물품이 박스 사이에 껴있을 수 있음)</a></a>
                                    <div className="display-flex flex-row wd-100pc m-t-12 gap20">
                                        <div className="display-flex flex-row wd-50pc gap15">
                                            <div className="display-flex flex-column wd-100pc">
                                                <div>*올바른 예</div>
                                                <div className="display-flex flex-row wd-100pc gap15">
                                                    <img className="wd-45pc ht-400 border-rd8" alt="" src={packEx1}/>
                                                    <img className="wd-45pc ht-400 border-rd8" alt="" src={packEx2}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="display-flex flex-row wd-50pc gap15">
                                            <div className="display-flex flex-column wd-100pc">
                                                <div>*잘못된 예</div>
                                                <div className="display-flex flex-row wd-100pc gap15">
                                                    {/*<img className="wd-45pc ht-400 border-rd8" alt="" src={packEx1}/>*/}
                                                    {/*<img className="wd-45pc ht-400 border-rd8" alt="" src={packEx2}/>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/><br/><br/>
                                    <a>4. 패킹 완료 후 <a style={{fontWeight: "bold", fontSize: "18px"}}>가로 X 세로 X 높이 및 실중량</a>을 측정하여 박스에 측정한 값과 수취인명(정확하게(영문)) 기입 (※ 아래 예시 이미지 참조)</a>
                                    <div className="display-flex flex-row wd-100pc m-t-10 gap20">
                                        <div className="display-flex flex-row wd-50pc gap15">
                                            <div className="display-flex flex-column wd-100pc">
                                                <div className="display-flex flex-row wd-100pc gap15">
                                                    <img className="wd-50pc ht-250 border-rd8" alt="" src={packEx3}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/><br/><br/>
                                    <a>5. 위 절차에서 기입한 박스 중량의 값을 <a style={{fontWeight: "bold"}}>[비용등록]</a> 화면에서 입력 후 상품 할당하여 등록(배송비 외 기타비용들이 존재하면 같이 입력)</a>
                                    <br/><br/><br/>
                                    <a>6. 1~5 절차 완료 시 출고존에 박스 적재</a>
                                    <br/><br/><br/>
                                    <a>ℹ️ 참고사항: </a>
                                </TaskToggleSection>
                                <TaskToggleSection title="배송접수 가이드라인">
                                    <SubToggleSection title="EMS">
                                        <p>1. 오전 10:10에 접수 시작</p>
                                        <p>2. Receipt List(접수리스트)에서 EMS건 선택하여 API출고처리</p>
                                        <p>3. 부득이한 상황의 경우 엑셀 내려받아서 수동 출고처리(수취인정보 및 각 정보들 자세히 확인)</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="FedEx">
                                        <p>1. 오후 13시:10에 접수 시작</p>
                                        <p>2. Receipt List(접수리스트)에서 FedEX건 선택 후 엑셀 다운로드</p>
                                        <p>3. 다운받은 엑셀파일과 FedEx 접수양식(Excel) 동시에 실행</p>
                                        <p>4. 다운받은 엑셀의 내용을 복사 하여 접수양식에 붙여넣기</p>
                                        <p>5. 해당 엑셀의 좌측 상단에 Generate 클릭하여 .in파일 저장</p>
                                        <p>6. FedEx 배송 사이트에 접속하여 해당 in파일 업로드 후 진행</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="UPS">
                                        <p>상세설명</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="선편(SEA)">
                                        <a href="https://ems.epost.go.kr/front.SmEmsAcceptIntro.postal" target="_blank" className="text-underline" style={{color: "#1f67ff"}}>https://ems.epost.go.kr/front.SmEmsAcceptIntro.postal</a>
                                        <p>1. 위 링크 접속하여 우체국(국제소포) 탭 클릭</p>
                                        <p>2. 국가 및 수취인정보, 패킹정보 입력 후 접수 진행</p>
                                    </SubToggleSection>
                                </TaskToggleSection>
                                <TaskToggleSection title="고객별 패킹/접수 참고사항">
                                    <SubToggleSection title="산드라">
                                        <p>요청번호(PRN)</p>
                                        <p>1. 30gk(선편은 20kg)까지 패킹 / 분할 가능(두번 째 박스는 무게 상관없이 무조건 패킹)</p>
                                        <p>2. 30gk(선편은 20kg)까지 패킹 / 분할 가능(두번째 박스는 30kg 미만 시 보관)</p>
                                        <p>3. 30gk(선편은 20kg)까지 패킹 / 분할 불가능(두번 째 박스는 무게 상관없이 무조건 패킹)</p>
                                        <p>4. 30gk(선편은 20kg)까지 패킹 / 분할 불가능(두번째 박스는 30kg 미만 시 보관</p>
                                        <p>5. 통합, 분리 없도착한 그대로 패킹</p>
                                        <p>6. 아래 조건에 따라 버블랩+이중박스 및 1~2층 포장 = 10kg당 3,000원</p>
                                        <p>&nbsp;&nbsp;- 2층이 무거울 경우 1층은 세로로 이중박스 패킹, 2층의 상품도 서로 눌리지 않게 패킹하고 버블랩</p>
                                        <p>&nbsp;&nbsp;- 1층으로만 포장된다면 세로로 세워서 이중박스 혹은 버블랩</p>
                                        <p>7. 파손주의, 박스를 뒤집지마세요 문구 스티커 부착</p>
                                        <p>8. 포토카드 구겨지지 않게 패킹</p>
                                        <p>9. 포스터 통합(1개당 1,000원)</p>
                                        <p>10. 이중박스 및 1~2층 포장(2층이 무거울 경우 1층은 무조건 앨범을 세워서 이중박스 포장) = 10kg당 2,000원 부과(1층)</p>
                                        <br />
                                        <p>ㆍ수취인 성함이 "Sandra"일 경우 기본요청사항</p>
                                        <p>&nbsp;- 도착 시 택배박스 안에 공간이 일체 없다면 그대로 포장</p>
                                        <p>&nbsp;- 앨범을 세로로 세우기 위해 1~2층 공간이 맞지 않다면 꼭 30kg를 채우지 않고 두 번째 박스로 분류가능</p>
                                        <p>&nbsp;- 상자제거 시 뾱뾱이로 2~3겹 랩핑 후 운송장 뒤 4자리 수 기입(옷, 인형 등 파손위험 없는 물품 제외)</p>
                                        <p>&nbsp;- 겉박스(EMS박스)는 상단/하단에 버블랩 추가X(밑에 뾱뾱이 깔기 x)</p>
                                        <p>&nbsp;- 겉박스(EMS박스) 닫기 전 사진캡처 후 카톡으로 첨부, 파손주의 스티커 부착</p>
                                        <p>&nbsp;- 이 외 추가 요청사항은 주문서 댓글 및 요청사항 내용 확인</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="비티오코리아">
                                        <p>ㆍ도착한 그대로 배송되거나 혹은 여러 고객님들의 주문 건이 한 박스로 도착할 경우에만 여러 박스에 분류작업</p>
                                        <p>ㆍ항상 비티오코리아 측에서 수출신고, 보세건으로 선적신고</p>
                                        <p>ㆍ모든 발송 100% 간이 수출신고 면장 + 인보이스 첨부</p>
                                        <p>ㆍ운송장 발송인(Btorage) 앞에 'bigtentoutdoors' 추가하여 접수(계약 할인에 영향이 없을 경우만)</p>
                                        <p>ㆍ모든 입고 소포물에 있는 거래처의 주문정보 제거(부착물 등)</p>
                                        <p>ㆍ운송장번호 없이 사서함번호로 입고확인</p>
                                        <br />
                                        <p>ㆍ사업자등록증 + 면장 받아야 하고 FedEx 접수 시 세관신고금액과 면장금액이 동일해야 함</p>
                                        <p>ㆍ해외로 출고 직후에 수출신고내역서 메일로 첨부해주고 영세율 계싼서 발행</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="김지민">
                                        <p>ㆍ한박스당 최대한 40kg미만 패킹, 반드시 인보이스 부착 및 메일발송</p>
                                        <p>rvsmtown2001@gmail.com</p>
                                        <p>[비토리지] 뉴질랜드 FedEX 인보이스 영수증 첨부 안내</p>
                                        <p>안녕하세요 지민님^^*~</p>
                                        <p>FedEX 인보이스(영수증형) 첨부 드립니다.</p>
                                        <p>좋은하루 되세요 :)</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="Livian">
                                        <p>ㆍ한박스 최대 30kg까지 패킹 후 다음 박스는 임의로 아무거나 나눠서 패킹. 특이사항 없는 이상 웬만하면 선출고</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="이찬주">
                                        <p>ㆍ각종 MSDS 인쇄비용 장당 200원</p>
                                        <p>ㆍ인보이스 작성 및 메일첨부 비용 10,000원</p>
                                        <p>ㆍ구매대행이어도 적립 X</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="이재일">
                                        <p>ㆍ패킹 완료 후 관리자 권한으로 예치금결제 처리하여 출고처리</p>
                                        <p>ㆍ배송비안내 X</p>
                                        <p>ㆍ접수 시 내용품명 정확하게, 세관심고금액 정확한 환율 금액에서 10% 제외한 금액</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="소진">
                                        <p>ㆍ배송대행에 배송비 등록</p>
                                        <p>ㆍ접수 시 엑셀 또는 수취인정보 입력란에서 이메일 지워야 함</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="박민선">
                                        <p>ㆍ출고 후 운송장 캡처하여 카톡 전송</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="John">
                                        <p>ㆍ패킹 후 예치금으로 출고처리(예치금 부족하면 출고처리 하지 않고, 배송비 안내)</p>
                                        <p>ㆍ구매대행이어도 적립 X</p>
                                    </SubToggleSection>
                                    <SubToggleSection title="아넬">
                                        <p>ㆍ패킹 후 상태변경으로 결제완료 처리(예치금결제 아님★)하여 출고</p>
                                        <br/>
                                        <p>ㆍ출고 완료  해당 주문번호에 맞는 운송장번호 아넬 담당자에게 전달(카톡)</p>
                                        <p>안녕하세요 FedEx 출고건 입니다.</p>
                                        <p>주문번호: 1234567890</p>
                                        <p>운송장번호: 1234567890</p>
                                        <p>감사합니다 :)</p>
                                        <br/>
                                    </SubToggleSection>
                                    <SubToggleSection title="조성현">
                                        <p>ㆍ접수(출고) 완료 후 EMS영수증형 캡처하여 메일 첨부</p>
                                        <p>1tjdgus1@naver.com</p>
                                        <p>[비토리지] EMS 영수증 캡처본 첨부</p>
                                        <p>안녕하세요 성현님^^*~</p>
                                        <p>출고 완료 되었으며, 출고건에 대한 영수증형 캡처파일 첨부해 드립니다.</p>
                                        <p>감사합니다. 좋은하루 되세요 :)</p>
                                    </SubToggleSection>
                                </TaskToggleSection>
                                <div className="memo-container">
                                    <div className="post-it-xl" contentEditable>
                                        <p>⚠️패킹⚠️</p>
                                        <br/>
                                        <p className="font-b">ㆍFedEx 30kg 초과 시 배송비용 = 1kg당 x 아래 금액</p>
                                        <p>&nbsp;&nbsp;&nbsp;미국 11,900원 / 뉴질랜드 14,900원 / 싱가폴 7,900원 / 독일 14,200원 / 일본 8,200원</p>
                                        <br/>
                                        <p className="font-b">ㆍEMS 발송 불가품</p>
                                        <p>&nbsp;&nbsp;&nbsp;리튬배터리, 향수, 스프레이, 건전지 등</p>
                                        <br/>
                                        <p className="font-b">ㆍFedEx 추가취급용적 수수료</p>
                                        <p>&nbsp;&nbsp;&nbsp;1. 가장 긴 변의 길이가 121cm를 초과</p>
                                        <p>&nbsp;&nbsp;&nbsp;2. 두번째로 긴 변의 길이가 76cm를 초과</p>
                                        <p>&nbsp;&nbsp;&nbsp;3. 가장 긴 변의 길이와 둘레의 합이 266cm를 초과</p>
                                        <br/>
                                    </div>
                                    <div className="post-it-xl" contentEditable>
                                        <p>⚠️접수⚠️</p>
                                        <br/>
                                        <p className="font-b">ㆍ모든 배송사 공통 - 인보이스 작성(부착) 국가</p>
                                        <p>&nbsp;&nbsp;&nbsp;캄보디아, 멕시코, 프랑스, 스위스, 폴란드, 체코, 네덜란드 / 배송대행은 고객이 작성 해야 함</p>
                                        <br/>
                                        <p className="font-b">ㆍFedEx</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 250$ 이상일 경우 품명앞에 KRNAVER95BUD 붙여야 함(FedEx 미국만★)</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 미국 식품 또는 리스크 있는 물품 제외하고 최대한 정확하고 상세하게 기입(FedEx)</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 식품 또는 리스크 있는 품목은 기재 X(모든국가)</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 내용품명 최대한 정확, 상세하게 /  금액은 600$이하 까지 1번 고려하여 정확하게(미국만★)</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 30kg초과건 적립: 배송료 - 유류할증료의 5%</p>
                                        <br/>s
                                        <p className="font-b">ㆍEMS</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 베트남(EMS) - 중고물품, 앨범으로 접수 불가</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 독일 - 마스크 접수 불가</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 멕시코 - 인형 접수 불가</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 일본/우크라이나(EMS) - 모든 식품류 박스당 10kg정도 까지</p>
                                        <p>&nbsp;&nbsp;&nbsp;- 중국 - 아기분유는 박스당 6통만 가능, 비타민은 복불복</p>
                                    </div>
                                    <div className="post-it-l" contentEditable>
                                        <p>광주우체국 연락처 - 031-799-5146</p>
                                        <br/>
                                        <p className="font-b">FedEx 세관내용품명</p>
                                        <p>의류 - women cotton 100% tshirts and men cotton 100% pants for personal use5</p>
                                        <p>책 - books for personal use5</p>
                                        <p>악세사리 - daily accessories for personal use5</p>
                                        <p>화장품 - foam cleanging and suncream and face makeup plastic 100% brush for personal use10</p>
                                        <p>이불 - cotton 100% blanket for personal use1</p>
                                        <p>헤어샴푸 - hair treatment and shampoo for personal use3</p>
                                    </div>
                                    <div className="post-it-m" contentEditable>
                                        <p></p>
                                    </div>
                                    <div className="post-it-s" contentEditable>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        }
                        {activeCategory === "OutToReturn" &&
                            <div className="banner-info-container">

                            </div>
                        }
                    </div>
                </div>
            </div>
            <TopBtn/>
        </div>
    );
}

export default AdminTaskManagerPg
